import { render, staticRenderFns } from "./CustomTextBlock.vue?vue&type=template&id=1b5c3803&"
import script from "./CustomTextBlock.vue?vue&type=script&lang=js&"
export * from "./CustomTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports